module.exports = __webpack_public_path__ + "static/netbrainT-87d6418a3c4025ce222b917efda60253.png";